export const UPLOAD_DOC_REF_HEADER = "x-atgof-upload-doc-ref";
export const APP_VERSION_HEADER = "x-atgof-version";
export const SERVICE_WORKER_ERROR_HEADER = "x-service-worker-error";
